var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_102_1051)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.7266,
    cy: 32,
    r: 27,
    fill: "url(#paint0_linear_102_1051)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.7266,
    cy: 32,
    r: 26.25,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4176 22.6901C33.6616 22.6617 33.9086 22.7006 34.1321 22.8025C34.3556 22.9043 34.547 23.0654 34.6856 23.2682C36.6746 26.1775 39.0625 27.3876 41.7131 27.6625C41.8425 26.5292 42.1484 25.4094 42.7238 24.423C43.5674 22.9757 44.9392 21.9112 46.8985 21.5177C49.6071 20.9733 51.6689 21.9543 52.8642 23.155L55.279 22.7035C55.5317 22.6562 55.7927 22.6821 56.0311 22.7782C56.2695 22.8744 56.4755 23.0367 56.6247 23.2461C56.7739 23.4555 56.86 23.7032 56.873 23.96C56.886 24.2167 56.8253 24.4718 56.698 24.6952L54.3802 28.7675C54.5917 34.6442 52.9585 38.7462 49.4764 41.572C47.6303 43.0705 44.9864 43.9208 42.0851 44.1836C39.1609 44.4477 35.8553 44.1283 32.57 43.1689C32.2893 43.087 32.0428 42.916 31.8678 42.6818C31.6928 42.4476 31.5987 42.1627 31.5998 41.8703C31.6008 41.5779 31.697 41.2938 31.8737 41.0608C32.0504 40.8279 32.2981 40.6587 32.5794 40.5789C34.2315 40.1086 35.4901 39.703 36.6261 38.9928C35.0104 38.1358 33.8205 37.0146 32.9783 35.7371C31.8086 33.961 31.3747 31.9801 31.2884 30.1946C31.2022 28.4091 31.4596 26.7543 31.7318 25.5617C31.8868 24.8812 32.0673 24.1993 32.3166 23.5471C32.4046 23.3172 32.5538 23.1158 32.7481 22.9647C32.9424 22.8136 33.1731 22.7186 33.4176 22.6901Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_102_1051",
    x: 0.726562,
    y: 0,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.294118 0 0 0 0 0.72549 0 0 0 0 0.988235 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_1051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_1051",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_1051",
    x1: 15.7266,
    y1: 5,
    x2: 69.7266,
    y2: 59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59C0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2694a531a7598da4c2d6ffb7ab84df3a.svg";
export { ForwardRef as ReactComponent };